import type { AccessPayload } from '../types'
import type { StoredSessionProgress } from '../services/sessionProgress'

interface Props {
  access: AccessPayload
  availableQuestions: number
  savedProgress?: StoredSessionProgress | null
  onStart: () => void
  onExit: () => void
}

export function WelcomeScreen({ access, availableQuestions, savedProgress, onStart, onExit }: Props) {
  const { student, session, pendingSessions } = access
  const questionCount = Math.min(session.questionCount, availableQuestions)
  const completed = savedProgress?.questionResults.length ?? 0
  const total = savedProgress?.questionIds.length ?? questionCount
  return (
    <main id="main-content" className="welcome-page v3-welcome">
      <section className="welcome-card personalized-welcome">
        <p className="eyebrow">Sesión preparada especialmente para ti</p>
        <h1>Hola, {student.firstName} {student.lastName}</h1>
        <div className="message-card">
          <span>Mensaje de tu profesora</span>
          <p>{student.message}</p>
        </div>
        <div className="student-summary compact-summary">
          <div><span>Curso</span><strong>{student.course}</strong></div>
          <div><span>Sesión</span><strong>{session.title}</strong></div>
          <div><span>Sesiones disponibles</span><strong>{pendingSessions}</strong></div>
        </div>
      </section>

      <section className="assignment-card session-plan">
        <div className="assignment-heading"><span className="assignment-number">01</span><div><p className="step-label">Antes de comenzar</p><h2>{session.title}</h2></div></div>
        <div className="session-purpose">
          <article><span>Tema</span><strong>{session.topics.length ? session.topics.join(', ') : session.unit}</strong></article>
          <article><span>Objetivo</span><strong>{session.learningGoal || `Comprender y aplicar contenidos de ${session.selectedOAs.join(', ')}.`}</strong></article>
          <article><span>Habilidad histórica</span><strong>{session.historicalSkill || 'Analizar, comparar y explicar procesos históricos.'}</strong></article>
          <article><span>Actividades</span><strong>{total}</strong></article>
          <article><span>Materiales</span><strong>{session.materials || 'Cuaderno y lápiz.'}</strong></article>
          <article><span>Trabajo final</span><strong>Resumen estructurado en el cuaderno.</strong></article>
        </div>
        <div className="must-read"><strong>Lee antes de comenzar:</strong> responde cada actividad, utiliza la pista cuando la necesites y revisa la explicación antes de avanzar. Después de confirmar una respuesta no podrás volver atrás.</div>
        {savedProgress && <div className="saved-progress-card" role="status"><strong>Tu avance está guardado.</strong><span>Completaste {completed} de {total} actividades en este dispositivo.</span></div>}
        {availableQuestions === 0 && <p className="error-message">No se encontraron preguntas para esta asignación. La profesora debe revisar la configuración.</p>}
        <div className="button-row welcome-actions">
          <button className="primary-button large-start" onClick={onStart} disabled={availableQuestions === 0}>{savedProgress ? 'Continuar sesión' : 'Comenzar'}</button>
          <button className="secondary-button" onClick={onExit}>Salir</button>
        </div>
      </section>
    </main>
  )
}
